export default "__VITE_ASSET__Hpz6xBfj__"